// @flow

export function possessionize(noun: string) {
  const suffix = noun.toLowerCase().slice(-1) === 's' ? "'" : "'s";
  return `${noun}${suffix}`;
}
